import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Phone } from "lucide-react";

const links = [
  { label: "Storia", href: "#storia" },
  { label: "Piatti", href: "#piatti" },
  { label: "Menù", href: "#menu" },
  { label: "Orari", href: "#orari" },
  { label: "Contatti", href: "#contatti" },
];

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.header
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, delay: 0.4, ease: [0.22, 1, 0.36, 1] }}
      className={`fixed top-0 inset-x-0 z-50 transition-[background-color,box-shadow,border-color] duration-500 ${
        scrolled
          ? "bg-[#FAF8F5]/85 backdrop-blur-xl border-b border-[#E7E4DF] shadow-[0_1px_30px_rgba(28,25,23,0.06)]"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-16 h-16 sm:h-20 flex items-center justify-between">
        <a href="#top" data-testid="nav-logo" className="font-serif-display text-xl sm:text-2xl tracking-tight font-semibold">
          Baracca<span className="text-[#B87F1B]">.</span>
        </a>
        <nav className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className="font-mono-accent text-xs uppercase tracking-[0.2em] text-[#6E6A66] hover:text-[#1C1917] transition-colors duration-300"
            >
              {l.label}
            </a>
          ))}
        </nav>
        <a
          href="tel:01521941"
          data-testid="nav-call-button"
          className="group inline-flex items-center gap-2 rounded-full bg-[#1C1917] text-[#FAF8F5] px-4 sm:px-5 py-2 sm:py-2.5 text-xs sm:text-sm font-medium hover:bg-[#7A1C28] transition-colors duration-300"
        >
          <Phone size={14} className="transition-transform duration-300 group-hover:rotate-12" />
          015 21941
        </a>
      </div>
    </motion.header>
  );
};

export default Navbar;
